import { Stack, SvgIcon, Typography } from "@mui/material";

import { GaugeIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

import { NightReportMetric } from "interfaces/nightReport.interface";

import { MetricBadge } from "../../../../../NightReportScreen/components/MetricBadge";
import { StatCard } from "../components/StatCard";

type SleepScoreCardProps = {
  sleepScore: string;
  sleepScoreMetric: NightReportMetric | null;
};

export function SleepScoreCard({
  sleepScore,
  sleepScoreMetric,
}: SleepScoreCardProps) {
  const { t } = useTranslation();

  return (
    <StatCard>
      <SvgIcon component={GaugeIcon} color={"neutral.decoration"} />
      <Typography
        variant={"bodySmallMedium"}
        sx={{
          color: "neutral.subtle",
        }}
      >
        {t("Sleep Score")}
      </Typography>
      <Stack direction={"row"} sx={{ alignItems: "baseline", gap: 0.5 }}>
        <Typography variant={"headingLargeRegular"}>{sleepScore}</Typography>
        <Typography
          variant={"headingSmallSemibold"}
          sx={{
            color: "neutral.subtle",
          }}
        >
          {"/ 100"}
        </Typography>
      </Stack>
      {sleepScoreMetric?.deviation_pct && (
        <MetricBadge
          showPercent
          metric={sleepScoreMetric}
          delta={sleepScoreMetric.deviation_pct}
          sx={{ alignSelf: "self-start" }}
        />
      )}
    </StatCard>
  );
}
